// extracted by mini-css-extract-plugin
module.exports = {"PageContainer":"PageContainer_PageContainer__2uUXY"};